//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create organization ------------
export const createOrganization = () => ({ type: ActionTypes.organizations.createOrganization });
export const createOrganizationFail = (returnedPayload) => ({ type: ActionTypes.organizations.createOrganizationFail, payload: returnedPayload });
export const createOrganizationSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.createOrganizationSuccess, payload: returnedPayload });

//  -- Get organization ---------------
export const getOrganization = () => ({ type: ActionTypes.organizations.getOrganization });
export const getOrganizationFail = (returnedPayload) => ({ type: ActionTypes.organizations.getOrganizationFail, payload: returnedPayload });
export const getOrganizationSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.getOrganizationSuccess, payload: returnedPayload });
export const getOrganizationPermissionSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.getOrganizationPermissionSuccess, payload: returnedPayload });

//  -- List organizations -------------
export const listOrganizations = () => ({ type: ActionTypes.organizations.listOrganizations });
export const listOrganizationsFail = (returnedPayload) => ({ type: ActionTypes.organizations.listOrganizationsFail, payload: returnedPayload });
export const listOrganizationsSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.listOrganizationsSuccess, payload: returnedPayload });

//  -- List schools -------------------
export const listOrgsByParent = () => ({ type: ActionTypes.organizations.listOrgsByParent });
export const listOrgsByParentFail = (returnedPayload) => ({ type: ActionTypes.organizations.listOrgsByParentFail, payload: returnedPayload });
export const listOrgsByParentSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.listOrgsByParentSuccess, payload: returnedPayload });

//  -- List districts -----------------
export const listDistricts = () => ({ type: ActionTypes.organizations.listDistricts });
export const listDistrictsFail = (returnedPayload) => ({ type: ActionTypes.organizations.listDistrictsFail, payload: returnedPayload });
export const listDistrictsSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.listDistrictsSuccess, payload: returnedPayload });
export const updateDistrictsSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.updateDistrictsSuccess, payload: returnedPayload });

//  -- List all Schools -----------------
export const listAllSchools = () => ({ type: ActionTypes.organizations.listAllSchools });
export const listAllSchoolsFail = (returnedPayload) => ({ type: ActionTypes.organizations.listAllSchoolsFail, payload: returnedPayload });
export const listAllSchoolsSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.listAllSchoolsSuccess, payload: returnedPayload });

//  -- List schools -------------------
export const listSchools = () => ({ type: ActionTypes.organizations.listSchools });
export const listSchoolsFail = (returnedPayload) => ({ type: ActionTypes.organizations.listSchoolsFail, payload: returnedPayload });
export const listSchoolsSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.listSchoolsSuccess, payload: returnedPayload });

export const listorgTeacherData = () => ({ type: ActionTypes.orgTeacher.listOrgTeacherData });
export const listorgTeacherDataSuccess =  (returnedPayload) => ({ type: ActionTypes.orgTeacher.listOrgTeacherDataSuccess, payload: returnedPayload });

//  -- Update organization ------------
export const updateOrganization = () => ({ type: ActionTypes.organizations.updateOrganization });
export const updateOrganizationFail = (returnedPayload) => ({ type: ActionTypes.organizations.updateOrganizationFail, payload: returnedPayload });
export const updateOrganizationSuccess = (returnedPayload) => ({ type: ActionTypes.organizations.updateOrganizationSuccess, payload: returnedPayload });


export const setDistDashboardInfo = (returnedPayload) => ({ type: ActionTypes.distDashboardInfo.setDistDashboardInfo , payload: returnedPayload });
export const updateDistDashboardInfo = (returnedPayload) => ({ type: ActionTypes.distDashboardInfo.updateDistDashboardInfo, payload: returnedPayload });
export const clearDistDashboardInfo = () => ({ type: ActionTypes.distDashboardInfo.clearDistDashboardInfo});

export const setDistExamGraphData = (returnedPayload) => ({ type: ActionTypes.distDashboardInfo.setExamsGraphData , payload: returnedPayload });
export const clearDistExamGraphData= () => ({ type: ActionTypes.distDashboardInfo.clearExamsGraphData});

export const updateDistBookUsesGraphData = (returnedPayload) => ({ type: ActionTypes.distDashboardInfo.updateBookUsesGraphData, payload: returnedPayload });


export const setDistContentExamGraphData = (returnedPayload) => ({ type: ActionTypes.distDashboardInfo.setContentExamGraphData , payload: returnedPayload });


export const setVocabPermissionForUser = (returnedPayload) => ({ type: ActionTypes.vocab_permission.set_vocab_permission , payload: returnedPayload });

export const setClassTogglePermission = (returnedPayload) => ({ type: ActionTypes.class_toggle_permission.set_class_toggle_permission , payload: returnedPayload });
export const updateClassTogglePermission = (returnedPayload) => ({ type: ActionTypes.class_toggle_permission.update_class_toggle_permission, payload: returnedPayload });
export const clearClassTogglePermission = () => ({ type: ActionTypes.class_toggle_permission.clear_class_toggle_permission});

export const setAdminHomeInfo = (returnedPayload) => ({ type: ActionTypes.adminHomeInfo.setAdminHomeInfo , payload: returnedPayload });
export const updateAdminHomeInfo = (returnedPayload) => ({ type: ActionTypes.adminHomeInfo.updateAdminHomeInfo, payload: returnedPayload });